import { useMutation } from '@tanstack/react-query';

export default function useDeleteOrganizationNotification() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async () => {
      const response = await fetch('/agent/api/organization_notification', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({}),
      });
      return await response.json();
    },
  });
}
